import {useContext} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {ProjectPermission} from "../../api/authority/generated/index";

export function useIsAdministrator() {
    let {context} = useContext(GlobalContext);
    return context?.currentIdentity?.user?.isAdministrator === true;
}

export function useHasPermission() {
    let isAdministrator = useIsAdministrator();

    return (permission, projectOrProjectUser = null) => {
        if (isAdministrator) {
            return true;
        }

        if (projectOrProjectUser !== null) {
            return projectOrProjectUser.isOwner === true
                || projectOrProjectUser.permissions.includes(permission);
        }

        return false;
    };
}
